import { Text, TextProps } from '@chakra-ui/layout'
import React from 'react'
import { t, useTranslation } from 'i11n/client'

export interface ITranslatorProps extends TextProps {
  children: any
  mode?: 'onlyString' | 'component'
  prefix?: string
}

export const RenderDecider = (wordToTranslate: string) => t(wordToTranslate)

export const TranslatorOnlyString = (
  props: Pick<ITranslatorProps, 'children'>,
) => {
  return RenderDecider(props.children)
}

export const Translator: React.FC<ITranslatorProps> = (props) => {
  const translate = useTranslation()

  return (
    <Text {...props}>
      {props.prefix} {translate(props.children)}
    </Text>
  )
}
